/** Массив хранящий все загруженные геозоны (с доп.информацией) */
export const setGeozoneArr = (geozoneArr) => {
  return {type: 'SET_GEOZONE_GEOZONE_ARR', payload:geozoneArr};
};
/** Массив настройки геозон (показ) */
export const setGeozoneSettingsArr = (geozoneSettingsArr) => {
  return {type: 'SET_GEOZONE_GEOZONE_SETTINGS_ARR', payload:geozoneSettingsArr};
};
/** Массив вершин (полигон в процессе рисования) */
export const setGeozoneVertexArr = (geozoneVertexArr) => {
  return {type: 'SET_GEOZONE_GEOZONE_VERTEX_ARR', payload:geozoneVertexArr};
};
